module.exports = __webpack_public_path__ + "static/media/gcp.d3f32efc.webp";